/*global Ractive, RedmarineUXTemplates, BaseComponent */

var SEGMENT_WIDTH = 200;

// Add component to Global Ractive object
Ractive.components['ux-segmentationlist'] = BaseComponent.extend({

	template: RedmarineUXTemplates.uxsegmentationlistUxsegmentationlist,

	// any default data
	data: {
		component: 'ux-segmentationlist',
		items: [],
		startIndex: 0,
		selectedIndex: -1,
		fireOnInitialSelection: true,
		segmentWidth: SEGMENT_WIDTH,
		isSelected: function(index) {
			return this.get('selectedIndex') === index;
		}
	},

	computed: {

		totalItems: function() {
			return this.get('items').length;
		},

		sliderWidth: function() {

			var sliderWidth = this.get('componentWidth'),
				navWidth = this.get('navWidth');

			// deduct the navigation button (next/prev) width from the slider
			// if they are visible
			if (this.get('showNextNav')) {
				sliderWidth -= navWidth;
			}
			if (this.get('showPrevNav')) {
				sliderWidth -= navWidth;
			}

			return sliderWidth;
		},

		// calculate the no. of visible items
		// based on the viewport width
		visible: function() {
			var width = this.get('componentWidth'),
				segWidth = this.get('segmentWidth'),
				totalItems = this.get('totalItems'),
				segments = Math.floor(width / segWidth);

			segments = (segments >= totalItems) ? totalItems : segments;

			return segments;
		},

		itemWidth: function() {
			return this.get('sliderWidth') / this.get('visible');
		},

		showPrevNav: function() {
			return this.get('startIndex') > 0;
		},

		showNextNav: function() {
			return this.get('startIndex') + this.get('visible') < this.get('items').length;
		},

		slidePosition: function() {

			var startIndex = this.get('startIndex'),
				itemWidth = this.get('itemWidth'),
				navWidth = this.get('navWidth'),
				position = 0;

			if (startIndex > 0) {

				position = (-1) * itemWidth * startIndex;

				if (this.get('showPrevNav')) {
					position += navWidth;
				}
			}

			return position;
		},

		pointerPosition: function() {
			var $pointer = this.get('$component').find('.pointer'),
				btnNavWidth = this.get('$component').find('.btn-nav').outerWidth(),
				itemWidth = this.get('itemWidth'),
				startIndex = this.get('startIndex'),
				selectedIndex = this.get('selectedIndex'),
				pointerPosition;


			pointerPosition = ((selectedIndex + 1) * itemWidth) -
				(startIndex * itemWidth) -
				itemWidth / 2 -
				$pointer.outerWidth() / 2;

			if (this.get('showPrevNav')) {
				pointerPosition += btnNavWidth;
			}

			return pointerPosition;
		},

		hidePointer: function() {
			var selectedIndex = this.get('selectedIndex'),
				startIndex = this.get('startIndex'),
				visible = this.get('visible');

			// hide the pointer if it is out of slider
			if (selectedIndex < startIndex) {
				return true;
			}
			if (selectedIndex >= startIndex + visible) {
				return true;
			}
		}
	},

	// add you behavious here
	onrender: function() {

		// move to next
		this.on('next', function(event) {
			var totalItems = this.get('totalItems'),
				visible = this.get('visible'),
				newStartIndex = this.get('startIndex') + visible;

			if (newStartIndex > totalItems - visible) {
				newStartIndex = totalItems - visible;
			}

			this.set('startIndex', newStartIndex);
		}.bind(this));

		// move to previous
		this.on('prev', function(event) {
			var visible = this.get('visible'),
				newStartIndex = this.get('startIndex') - visible;

			if (newStartIndex < 0) {
				newStartIndex = 0;
			}

			this.set('startIndex', newStartIndex);
		}.bind(this));

		this.on('select', function(event) {
			event.original.preventDefault();
			var selectedIndex = this.get('selectedIndex'),
				newIndex = parseInt(event.keypath.split('.').pop());
			if (selectedIndex !== newIndex) {
				this.set('selectedIndex', newIndex).then(function() {
					this.fire('onSelect', this.get('items.' + newIndex));
				}.bind(this));
			}
		}.bind(this));

		// when the visible changes
		this.observe('visible', function(newVisible) {
			this.set('startIndex', 0);
		}.bind(this));

	},

	oncomplete: function() {

		this.set('$component', $('.' + this.get('component'))).then(function() {
			this.calcComponentWidth().then(function() {
				this.calcNavWidth();
			}.bind(this));
		}.bind(this))
		.then(function() {
			// check the widths
			this.calcComponentWidth().then(function() {
				this.calcNavWidth();
			}.bind(this));
		}.bind(this));

		// refresh the visible variable
		// to update the computed properties
		$(window).resize(function() {
			this.calcComponentWidth().then(function() {
				this.calcNavWidth();
				setTimeout(function() {
					this.calcNavWidth();
				}.bind(this), 100);
			}.bind(this));
		}.bind(this));


		if (this.get('fireOnInitialSelection')) {
			var item = this.get('items.' + this.get('selectedIndex'));
			this.fire('onSelect', item);
		}

		setTimeout(function() {
			this.calcComponentWidth().then(function() {
				this.calcNavWidth();
			}.bind(this));
		}.bind(this), 500);
	},

	calcComponentWidth: function() {
		return this.set('componentWidth', this.get('$component').outerWidth());
	},

	calcNavWidth: function() {
		this.set('navWidth', this.get('$component').find('.btn-nav:not(.hide)').outerWidth());
	}

});
